import store from '@/store';

export default class VoicePauseEvent {
  constructor(body) {
    if (
      store.state.attendance.Attendance.agentLoginStartsPaused.voice === true &&
      store.state.channel.latestVoiceStatusBeforeDisconnect.status ===
        'available' &&
      body.body.reason === 'Pausa Automatica Login'
    ) {
      store.dispatch('pause/unpauseAgentChannelVoice', {
        agentId: store.state.attendance.Attendance.agentId,
      });
      store.dispatch('channel/setLatestStatusBeforeDisconnect', true);
    } else {
      window.console.log(
        '%c [event]',
        'color: #F44336;',
        JSON.stringify(body, null, 4),
      );
      store.dispatch('pause/setPauseAgentChannelVoice', body.body.reason);
    }
  }
}
